import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import useMessageStore from "../../../../stores/message-store";
import Procard from "./procard/procard";
import useApi from "../../../../hooks/use-api";
import { EmptyStringToNull, NullableInputToEmptyString } from "../../../../utilities/rhfdatanormalizationfunctions";
import { useOutletContext } from "react-router-dom";

const EMPTY_CHECKLIST_DISPLAY = {
    housingreferraldate: '',
    hdireferraldate: '',
    facilitycontact: '',
    facilitycontactphone: ''
};

const TransitionCheckList = ({}) => {
    const {ApplicationID} = useOutletContext();

    const [isLoading,setIsLoading] = useState(true); //Start as true
    const [rttUserList,setRttUserList] = useState([]);
    const [sttRttUserAlternativeList,setSttRttUserAlternativeList] = useState([]);
    const [caseManagerList,setCaseManagerList] = useState([]);
    const [caseManagerAlternatives,setCaseManagerAlternatives] = useState([]);
    const [locationTypes,setLocationTypes] = useState([]);
    const [residenceTypes,setResidenceTypes] = useState([]);
    const [livesWithFamily,setLivesWithFamily] = useState([]);
    const [states,setStates] = useState([]);
    const [counties,setCounties] = useState([]);
    const [procards,setProcards] = useState([]);
    const [procardSttRttList,setProcardSttRttList] =  useState([]);
    const [procardAdditionalReasons,setProcardAdditionalReasons] = useState([]);
    const [userMasterList,setUserMasterList] = useState([]);
    const [alternativeProcardList,setAlternativeProcardList] =  useState([]);
    const [checklistDisplay,setChecklistDisplay] = useState(EMPTY_CHECKLIST_DISPLAY);
    // const [userMasterList,setUserMasterList] = useState([]);
    // const [cmError,setCMError] = useState(false);

    // const transitionChecklistData = useTransitionChecklistFetch(ApplicationID);

    // const extractedData = transitionChecklistData.data;

    // const{procards,...Data} = extractedData;

    const {getRequest,putRequest} = useApi();

    // // const [procardData,setProcardData] = useState(procards);

    // const update = useTestChecklistData(state => state.update);

    const initialValues = {
        id: 0,
         mdorderfornhdate: '',
         projectedtransitiondate: '',
         leasetobesigneddate: '',
         keysavailabledate: '',
         transitionaddress: '',
         transitioncity: '',
         transitionstate: '',
         transitionzip: '',
         transitioncounty: '',
         transitionphone: '',
         transitionlocationtype: '',
         provider: '',
         providernumber: '',
         providercontactfirstname: '',
         providercontactlastname: '',
         providercontactphone: '',
         provideraddress: '',
         providercity: '',
         providerstate: '',
         providerzip: '',
         providerphone: '',
         residencetype: '',
         liveswithfamily: '',
         casemanager: '',
         allphonenumberslisted: false,
         postedinnewhome: false,
         clientinstructed: false,
         emergencyplancompletedby: '',
         emergencyplancompletedate: ''
    }

    const {register,handleSubmit,reset,watch,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});

    // const compareObjects = (obj1, obj2) => {
    //     const keys1 = Object.keys(obj1);
    //     const keys2 = Object.keys(obj2);
    //     const allKeys = Array.from(new Set([...keys1, ...keys2])).sort();
      
    //     const differences = {};
      
    //     allKeys.forEach((key) => {
    //       if (obj1[key] !== obj2[key]) {
    //         differences[key] = { obj1: obj1[key], obj2: obj2[key] };
    //       }
    //     });
      
    //     return { areEqual: Object.keys(differences).length === 0, differences };
    //   };
      
    const processCmField = (cmString) => {
        let result = { casemanager: null, alternativecasemanager: null };
    
        if (cmString === '') {
          return result;
        }
    
        const cmValue = parseInt(cmString);
    
        if (cmValue < 0) {
          result.alternativecasemanager = Math.abs(cmValue);
        } else {
          result.casemanager = cmValue;
        }
    
        return result;
    };

    const processEmField = (emString) => {
        let result = { emergencyplancompletedby: null, emergencyplancompletedbyalternative: null };
    
        if (emString === '') {
          return result;
        }
    
        const emValue = parseInt(emString);
    
        if (emValue < 0) {
          result.emergencyplancompletedbyalternative = Math.abs(emValue);
        } else {
          result.emergencyplancompletedby = emValue;
        }
    
        return result;
    }
    
    const prepareDataForSend = (data) => {
        const transformedObj = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                transformedObj[key] = EmptyStringToNull(data[key]);
            }
        }
        return transformedObj;

    }
      
      
      

    const _handleSubmit = async(dataVals) => {
        const {casemanager,emergencyplancompletedby,...restData} = dataVals;

        const processedcm = processCmField(casemanager);
        const proceseedem = processEmField(emergencyplancompletedby);

        const submitData = {
            ...restData,
            ...processedcm,
            ...proceseedem
        }

        const finalData = prepareDataForSend(submitData);

        const [data,status] = await putRequest('TransitionChecklist_Update',finalData);

        if(status === 200){
            const {id,casemanager,alternativecasemanager,emergencyplancompletedby,emergencyplancompletedbyalternative,...extract} = data; 

            delete extract.procards;
            delete extract.housingreferraldate;
            delete extract.hdireferraldate;
            delete extract.facilitycontact;
            delete extract.facilitycontactphone;

            const resetData = Object.fromEntries(
                Object.entries(extract).map(([key,value]) => [key,NullableInputToEmptyString(value)])
            );

            const resetValues = {
                id: id,
                ...resetData,
                casemanager: caseManagerNormilization(casemanager,alternativecasemanager),
                emergencyplancompletedby: emCompletedByNormilization(emergencyplancompletedby,emergencyplancompletedbyalternative)
            }

            reset(resetValues);

            addToast(
                {
                    id: Math.random(),
                    body: "The Checklist was succesfully updated!",
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                }
            )
        }
        else{
            addToast(
                {
                    id: Math.random(),
                    body: "An error occured when updating the checklist.",
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                }
            )
        }

        // console.log(areEqual);
        // console.log(differences);
        // update(data);

        // await new Promise(resolve => setTimeout(resolve, 1500));

        // reset(data);
    }

    const caseManagerNormilization = (caseManager,altCaseManager) => {
        if(caseManager === null & altCaseManager !== null){
            return `-${altCaseManager}`
        }
        else if(caseManager !== null & altCaseManager === null){
            return `${caseManager}`;
        }
        else if(caseManager === null & altCaseManager === null) {
            return '';
        }
        else{
            throw Error("Invalid case manager assigment");
        }
    }

    const emCompletedByNormilization = (emCompletedBy,emCompletedByAlt) => {
        if(emCompletedBy === null & emCompletedByAlt !== null){
            return `-${emCompletedByAlt}`
        }
        else if(emCompletedBy !== null & emCompletedByAlt === null){
            return `${emCompletedBy}`;
        }
        else if(emCompletedBy === null & emCompletedByAlt === null) {
            return '';
        }
        else{
            throw Error("Invalid case manager assigment");
        }
    }

    const get = async() => {
        const [definitionData,worksheetData] = await Promise.all([
            getRequest('TransitionChecklist_Definitions',{timestamp: Date.now()}),
            getRequest('TransitionChecklist',{ApplicationID: ApplicationID,timestamp: Date.now()})
        ]);

        setIsLoading(false);

        const [extractedDefinitionData,definitionStatus] = definitionData;
        const [extractedTCData,tcStatus] = worksheetData;

        if(definitionStatus === 200 && tcStatus === 200){
            setUserMasterList(extractedDefinitionData.usermasterlist);
            setRttUserList(extractedDefinitionData.rttlist);
            setCaseManagerList(extractedDefinitionData.casemanagers);
            setCaseManagerAlternatives(extractedDefinitionData.alternativecasemanagers);
            // setUserMasterList(extractedDefinitionData.usermasterlist);
            setLivesWithFamily(extractedDefinitionData.liveswithfamily);
            setResidenceTypes(extractedDefinitionData.residencetypes);
            setLocationTypes(extractedDefinitionData.locationtypes);
            setStates(extractedDefinitionData.states);
            setCounties(extractedDefinitionData.counties);

            setProcardSttRttList(extractedDefinitionData.sttrttlist);
            setProcardAdditionalReasons(extractedDefinitionData.procardadditionalreasons);
            setAlternativeProcardList(extractedDefinitionData.alternativeprocardlist);
            setSttRttUserAlternativeList(extractedDefinitionData.alternativesttrtt);
            console.log(extractedDefinitionData.alternativesttrtt);

            const {
                id,
                casemanager,
                alternativecasemanager,
                emergencyplancompletedby,
                emergencyplancompletedbyalternative,
                procards,
                housingreferraldate,
                hdireferraldate,
                facilitycontact,
                facilitycontactphone,
                ...extract
            } = extractedTCData;

            setProcards(procards);
            setChecklistDisplay({
                housingreferraldate,
                hdireferraldate,
                facilitycontact,
                facilitycontactphone
            });
            
            if(casemanager !== null){
                //Rectify list
                if(!extractedDefinitionData.casemanagers.find(item => item.id === casemanager)){
                    //Not found in primary list
                    const masterRef = extractedDefinitionData.usermasterlist.find(item => item.id === casemanager);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }

                    setCaseManagerList([inactiveItem,...extractedDefinitionData.casemanagers]);
                }
            }

            if(emergencyplancompletedby !== null){
                if(!extractedDefinitionData.rttlist.find(item => item.id === emergencyplancompletedby)){
                    const masterRef = extractedDefinitionData.usermasterlist.find(item => item.id === emergencyplancompletedby);
                    const inactiveItem = {
                        ...masterRef,
                        Inactive: true
                    }

                    setRttUserList([inactiveItem,...extractedDefinitionData.rttlist]);
                }
            }

            const resetData = Object.fromEntries(
                Object.entries(extract).map(([key,value]) => [key,NullableInputToEmptyString(value)])
            );

            const resetValues = {
                id: id,
                ...resetData,
                casemanager: caseManagerNormilization(casemanager,alternativecasemanager),
                emergencyplancompletedby: emCompletedByNormilization(emergencyplancompletedby,emergencyplancompletedbyalternative)
            }

            reset(resetValues);
        }
    }

    const _addProcard = (data) => {
        setProcards(prev => [...prev,data]);
    }

    const _updateProcard = (data) => {
        setProcards(prev => 
            prev.map(item => (item.id === data.id ? {...item,...data} : item))
        );
    }

    useEffect(() => {
        get();
    },[])

    const addToast = useMessageStore(state => state.addToast);
    const displayValue = (value) => value || 'N/A';

    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    const casemanagerid = watch('casemanager');
    const emcompletedbyid = watch('emergencyplancompletedby');

    const casemanagererror = casemanagerid !== '' 
    ?
        parseInt(casemanagerid) > 0
        ?
            caseManagerList.find(item => item.id === parseInt(casemanagerid)).Inactive
        :
            false
    :
        false

    const emcompletedbyerror = emcompletedbyid !== ''
    ?
        parseInt(emcompletedbyid) > 0
        ?
            rttUserList.find(item => item.id === parseInt(emcompletedbyid)).Inactive
        :
            false
    :
        false
        
    return(
        <Row>
            <Col xs={12}>
            <form onSubmit={handleSubmit(_handleSubmit)}>
                <div className="clientCard">
                    <div className="clientCardInner">
                        <h4 className="text-center">Transition Checklist</h4>
                        <div className="mb-2">
                            <strong>Housing Referral Date</strong>
                            <p className="mb-2">{displayValue(checklistDisplay.housingreferraldate)}</p>
                            <strong>HDI Referral Made Date</strong>
                            <p className="mb-0">{displayValue(checklistDisplay.hdireferraldate)}</p>
                        </div>
                        <Procard
                            ApplicationID={ApplicationID} 
                            UserMasterList={userMasterList} 
                            Procards={procards} 
                            RequestedBy={procardSttRttList} 
                            RequestedByAlternatives={alternativeProcardList} 
                            Additional={procardAdditionalReasons}
                            addProcard={_addProcard}
                            updateProcard={_updateProcard}
                        />
                        <div style={{borderBottom: '1px solid black'}}>
                            <Row className="mt-4 mb-4">
                                <Col xs={12}>
                                    <h6 className="fw-bold text-center">Transition Information</h6>
                                </Col>
                                <Col xs={12} md={6} lg={4}>
                                    <strong>Facility Contact</strong>
                                    <p className="mb-2">{displayValue(checklistDisplay.facilitycontact)}</p>
                                    <strong>Facility Contact Phone</strong>
                                    <p className="mb-2">{displayValue(checklistDisplay.facilitycontactphone)}</p>
                                    <Row className="mb-2">
                                        <Col xs={12}>
                                            <label className="fw-bold" htmlFor="mdorder">MD orders for NH Requested Date</label>
                                            <input {...register('mdorderfornhdate')} type="date" id="mdorder" style={{width: '100%'}}/>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs={12}>
                                            <label className="fw-bold" htmlFor="mdtransdate">Projected Transition Date</label>
                                            <input {...register('projectedtransitiondate')} type="date" id="mdtransdate" style={{width: '100%'}} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs={12}>
                                            <label className="fw-bold" htmlFor="leasesigneddate">Lease to be signed Date</label>
                                            <input {...register('leasetobesigneddate')} type="date" id="leasesigneddate" style={{width: '100%'}} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <label className="fw-bold" htmlFor="keysdate">Keys available Date</label>
                                            <input {...register('keysavailabledate')} type="date" id="keysdate" style={{width: '100%'}} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={6} lg={8} className="mt-2">
                                    <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                                        <div className="d-flex justify-content-center">
                                            <strong>Transition Location</strong>
                                        </div>
                                        <Row>
                                            <Col xs={12} className="mb-1">
                                                <label htmlFor="transitionaddress">Transition Address</label>
                                                <input {...register('transitionaddress')} type="text" id="transitionaddress" style={{width: '100%'}} />
                                            </Col>
                                            <Col xs={12} md={4} className="mb-1">
                                                <label htmlFor="transitioncity">City</label>
                                                <input {...register('transitioncity')} type="text" id="transitioncity" style={{width: '100%'}} />
                                            </Col>
                                            <Col xs={12} md={4} className="mb-1">
                                                <label htmlFor="transitionstate">State</label>
                                                <select {...register('transitionstate')} id="transitionstate" style={{width: '100%', height: '30px'}}>
                                                    <option value=''>--Select State--</option>
                                                    {
                                                        states.map((state) => (
                                                            <option key={state.id} value={state.id}>{state.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </Col>
                                            <Col xs={12} md={4} className="mb-1">
                                                <label htmlFor="transitionzip">Zip</label>
                                                <input {...register('transitionzip')} type="text" id="transitionzip" style={{width: '100%'}} />
                                            </Col>
                                            <Col xs={12} md={4} className="mb-1">
                                                <label htmlFor="transitioncounty">Transition County</label>
                                                <select {...register('transitioncounty')} id="transitioncounty" style={{width: '100%', height: '30px'}}>
                                                    <option value=''>--Select County--</option>
                                                    {
                                                        counties.map((county) => (
                                                            <option key={county.id} value={county.id}>{county.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </Col>
                                            <Col xs={12} md={4} className="mb-1">
                                                <label htmlFor="transitionphone">Phone</label>
                                                <input {...register('transitionphone')} type="text" id="transitionphone" style={{width: '100%'}} />
                                            </Col>
                                            <Col xs={12} className="mb-1">
                                                <fieldset>
                                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Transition Location Type</legend>
                                                    {
                                                        locationTypes.map((item,index) => (
                                                            <div key={item.id}>
                                                                <input {...register('transitionlocationtype')} type="radio" name="transitionlocationtype" id={`tloctype${index}`} value={item.id} />
                                                                <label htmlFor={`tloctype${index}`}>{item.name}</label>
                                                            </div>
                                                        ))
                                                    }
                                                </fieldset>
                                                {/* <fieldset>
                                                    <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Transition Location Type</legend>
                                                    {
                                                        transitionChecklistData.lookup.transitionlocationtypes.map((item,index) => (
                                                            <div key={item.value}>
                                                                <input {...register('transitionlocationtype')} type="radio" name="transitionlocationtype" id={`tloctype${index}`} value={item.value} />
                                                                <label htmlFor={`tloctype${index}`}>{item.label}</label>
                                                            </div>
                                                        ))
                                                    }
                                                </fieldset> */}
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div style={{borderBottom: '1px solid black'}} className="mt-2">
                            <Row >
                                <Col xs={12}>
                                    <h6 className="fw-bold text-center">ABI and/or IDD Residential Provider Information</h6>
                                </Col>
                                <Col xs={12} md={8} className="mb-2">
                                    <label htmlFor="provider">Provider</label>
                                    <input {...register('provider')} type="text" id="provider" style={{width: '100%'}} />
                                </Col>
                                <Col xs={12} md={4} className="mb-2">
                                    <label htmlFor="providernumber">Provider Number</label>
                                    <input {...register('providernumber')} type="text" id="providernumber" style={{width: '100%'}} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6} className="mb-2">
                                    <label htmlFor="providercontactfirstname">Provider Contact First Name</label>
                                    <input {...register('providercontactfirstname')} type="text" id="providercontactfirstname" style={{width: '100%'}} />
                                </Col>
                                <Col xs={12} md={6} className="mb-2">
                                    <label htmlFor="providercontactlastname">Provider Contact Last Name</label>
                                    <input {...register('providercontactlastname')} type="text" id="providercontactlastname" style={{width: '100%',boxSizing: 'border-box'}}/>
                                </Col>
                                <Col xs={12} md={6} className="mb-2">
                                    <label htmlFor="providercontactphone">Provider Contact Phone</label>
                                    <input {...register('providercontactphone')} type="text" id="providercontactphone" style={{width: '100%'}} />
                                </Col>
                            </Row>
                            <Row >
                                <Col xs={12} md={4} className="mb-2">
                                    <label htmlFor="provideraddress">Provider Address</label>
                                    <input {...register('provideraddress')} type="text" id="provideraddress" style={{width: '100%'}} />
                                </Col>
                                <Col xs={12} md={3} className="mb-2">
                                    <label htmlFor="providercity">Provider City</label>
                                    <input {...register('providercity')} type="text" id="providercity" style={{width: '100%'}} />
                                </Col>
                                <Col xs={12} md={3} className="mb-2">
                                    <label htmlFor="providerstate">Provider State</label>
                                    <select {...register('providerstate')} id="providerstate" style={{width: '100%', height: '30px'}}>
                                        <option value=''>--Select State--</option>
                                    {
                                        states.map((state) => (
                                            <option key={state.id} value={state.id}>{state.name}</option>
                                        ))
                                    }
                                    </select>
                                </Col>
                                <Col xs={12} md={2} className="mb-2">
                                    <label htmlFor="providerzip">Provider Zip</label>
                                    <input {...register('providerzip')} type="text" id="providerzip" style={{width: '100%'}} />
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col xs={12} md={3}>
                                    <label htmlFor="providerphone">Provider Phone</label>
                                    <input {...register('providerphone')} type="text" id="providerphone" style={{width: '100%'}} />
                                </Col>
                            </Row>
                        </div>
                        <div style={{borderBottom: '1px solid black'}} className="mt-2">
                            <Row className="mb-4">
                                <Col xs={12}>
                                    <h6 className="fw-bold text-center">Residence Information</h6>
                                </Col>
                                <Col xs={12} className="mb-2">
                                    <label htmlFor="residencetype">Type of Residence</label>
                                    <select {...register('residencetype')} id="residencetype" style={{width: '100%'}}>
                                        <option value=''>--Select Residence Type--</option>
                                        {
                                            residenceTypes.map((item) => (
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            ))
                                        }
                                    </select>
                                </Col>
                                <Col xs={12} className="mb-2">
                                    <fieldset>
                                        <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Does participant live with Family members?</legend>
                                        {
                                            livesWithFamily.map((item,index) => (
                                                <div key={item.id}>
                                                    <input {...register('liveswithfamily')} type="radio" id={`familylivewith${index}`} value={item.id} name="liveswithfamily"/>
                                                    <label htmlFor={`familylivewith${index}`}>{item.name}</label>
                                                </div>
                                            ))
                                        }
                                    </fieldset>
                                    {/* <fieldset>
                                        <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Does participant live with Family members?</legend>
                                        {
                                            transitionChecklistData.lookup.livewithfamily.map((item,index) => (
                                                <div key={item.value}>
                                                    <input {...register('liveswithfamily')} type="radio" id={`familylivewith${index}`} value={item.value} name="liveswithfamily"/>
                                                    <label htmlFor={`familylivewith${index}`}>{item.label}</label>
                                                </div>
                                            ))
                                        }
                                    </fieldset> */}
                                </Col>
                                <Col xs={12}>
                                    <label htmlFor="casemanager">Case Manager</label>
                                    <select {...register('casemanager')} id="casemanager" style={{width: '100%',color: casemanagererror ? 'red' : 'black'}}>
                                        <option value='' style={{color: 'black'}}>--Select Case Manager--</option>
                                        {
                                            caseManagerAlternatives.map((item) => (
                                                <option key={item.id} value={`-${item.id}`} style={{color: 'black'}}>{item.name}</option>
                                            ))
                                        }
                                        {
                                            caseManagerList.map((item) => (
                                                <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                            ))
                                        }
                                    </select>
                                </Col>
                            </Row>
                        </div>
                        <div style={{borderBottom: '1px solid black'}} className="mt-2">
                            <Row className="mb-4">
                                <Col xs={12}>
                                    <h6 className="fw-bold text-center">Emergency Plan</h6>
                                </Col>
                                <Col xs={12} md={6}>
                                    <fieldset>
                                        <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Emergency Plan Checks</legend>
                                        <div>
                                            <label>
                                                <input type="checkbox" {...register('allphonenumberslisted')}/>
                                                All Attendants/caregivers/phone numbers listed
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="checkbox" {...register('postedinnewhome')}/>
                                                Posted in new home
                                            </label>
                                        </div>
                                        <div>
                                            <label>
                                                <input type="checkbox" {...register('clientinstructed')}/>
                                                Client instructed on plan
                                            </label>
                                        </div>
                                    </fieldset>
                                </Col>
                                <Col xs={12} md={3}>
                                    <label htmlFor="emplanby">Emergency Plan Completed By</label>
                                    <select {...register('emergencyplancompletedby')} id="emplanby" style={{width: '100%',color: emcompletedbyerror ? 'red' : 'black'}}>
                                        <option value='' style={{color: 'black'}}>--Select User--</option>
                                        {
                                            sttRttUserAlternativeList.map((item) => (
                                                <option key={item.id} value={`-${item.id}`} style={{color: 'black'}}>{item.name}</option>
                                            ))
                                        }
                                        {
                                            rttUserList.map((item) => (
                                                <option key={item.id} value={item.id} style={{color: item.Inactive ? 'red' : 'black'}} disabled={item.Inactive}>{item.name} {item.Inactive ? <>-- No Longer Active</> : null}</option>
                                            ))
                                        }
                                    </select>
                                </Col>
                                <Col xs={12} md={3}>
                                    <label htmlFor="emplandate">Emergency Plan Completed Date</label>
                                    <input {...register('emergencyplancompletedate')} type="date" id="emplandate" style={{width: '100%'}} />
                                </Col>
                            </Row>
                        </div>
                        <Row className="mt-2">
                            <Col xs={12}>
                                <div className="d-flex justify-content-end">
                                    <Button type="submit" variant="primary" disabled={!isDirty || isSubmitting}>
                                        {
                                            isSubmitting
                                            ?
                                                <Spinner animation='border' size='sm' />
                                            :
                                                <>Save Changes</>
                                        }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </form>
            </Col>
        </Row>
    )
}

export default TransitionCheckList;
